export default "__VITE_ASSET__43a38bc5__"